import { ReactNode } from 'react'

import styled from 'styled-components'
import { ColorProps, color, FontWeightProps, fontWeight, SpaceProps, space } from 'styled-system'

import { InputSmallText } from '@/atoms/typography'
import { filterStyledSystemProps } from '@/helpers/styled-props'

export const Text = styled(InputSmallText).withConfig({
  shouldForwardProp: filterStyledSystemProps(),
})<(ColorProps & SpaceProps & FontWeightProps) | { title: ReactNode }>`
  width: 100%;
  word-wrap: break-word;
  color: ${({ theme }) => theme.colors.heading};

  ${color}
  ${space}
  ${fontWeight}
`
